{
  "items": [
    {
      "fileName": "GENERIC-HumanAnimalMacro-01.mp4",
      "description": "The video shows one woman, a young adult female with dark hair, wearing a top, a gray, light gray long sleeve shirt, along with black pants, embracing a horse by wrapping her arms around its neck and resting her head against its mane, giving a calm, affectionate, peaceful visible expression. The horse is a large animal with a reddish brown, chestnut colored coat and a white blaze marking down its face, wearing a black leather halter or bridle with metal buckles. The setting is an outdoor rural countryside environment, showing an open grassy field, a wooden fence with posts in the distance, rolling hills covered in trees, and a hazy, sunlit sky. The lighting is extremely bright and warm, consistent with strong backlight sunlight low on the horizon, creating a glowing, hazy atmosphere and a soft lens flare near the horse's legs. The color palette is warm and golden, dominated by chestnut brown, tan, and gold tones, with a bright white glow from the sun. The composition is a medium shot, side angle framing, with the woman and horse positioned centrally in the frame against the open field. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a warm, golden hour glow and a moderate depth of field.",
      "keyElements": [
        "field",
        "fence",
        "hills",
        "trees",
        "sky",
        "halter",
        "bridle",
        "backlight",
        "lens flare",
        "lighting"
      ],
      "attributes": [
        "calm",
        "affectionate",
        "peaceful",
        "candid",
        "medium shot",
        "golden hour",
        "backlight",
        "lens flare",
        "warm lighting",
        "natural light",
        "warm tone",
        "hazy",
        "equestrian",
        "lifestyle",
        "woman",
        "horse",
        "chestnut",
        "brown",
        "halter",
        "bridle",
        "field",
        "fence",
        "hills",
        "countryside",
        "embrace"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-02.mp4",
      "description": "The video shows one man, an adult male with a tan skin tone and short dark hair, along with light facial stubble, wearing eyeglasses, thin wire framed eyeglasses, and a top, a green, olive colored sweater, along with blue denim jeans, smiling gently and looking downward at a dog, giving a warm, affectionate, calm visible expression, while holding a tablet, a black colored tablet computer, on his lap. The dog is a small animal with a tan, cream colored coat and floppy ears, sitting on the man's lap and looking upward at the man's face. The setting is an indoor living room environment, showing a gray sofa, a tan and cream colored patterned throw pillow, a green potted plant with large leaves, and a plain light gray wall in the background. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the man and dog without harsh shadows. The color palette is warm and neutral, dominated by green, tan, gray, and cream tones. The composition is a medium close up, closeup, upper body framing, with the man and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "potted plant",
        "wall",
        "tablet",
        "sweater color",
        "eyeglasses",
        "lighting"
      ],
      "attributes": [
        "warm",
        "affectionate",
        "calm",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "pet",
        "lifestyle",
        "man",
        "dog",
        "eyeglasses",
        "glasses",
        "green",
        "sweater",
        "tablet",
        "sofa",
        "plant",
        "throw pillow"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-03.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone and long, dark brown curly hair, wearing a top, a yellow button up shirt, along with white pants, kneeling on the floor and playing with two dogs, giving a joyful, warm, playful visible expression, with her mouth open in a smile. The two dogs are animals with a reddish brown, ginger colored coat, pointed ears, and curled tails, characteristic of a Shiba Inu breed, standing on their hind legs and interacting with the woman, one wearing a red collar. The setting is an indoor living room environment, showing a dark blue, navy colored wall, a black bookshelf holding books and small decorative objects, a light blue sofa with patterned throw pillows, a floor lamp with a white lampshade, sheer white curtains, and a framed abstract art print on the wall. The lighting is soft, bright, and natural, consistent with daylight coming through the curtains, evenly illuminating the scene. The color palette is warm and rich, dominated by navy blue, yellow, orange, and tan tones. The composition is a medium wide shot, full body framing, with the woman and dogs positioned across the frame in dynamic motion. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a bright, playful look and a moderate depth of field.",
      "keyElements": [
        "wall",
        "bookshelf",
        "books",
        "sofa",
        "throw pillows",
        "floor lamp",
        "curtains",
        "framed art print",
        "collar",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "playful",
        "candid",
        "action",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "warm tone",
        "pet",
        "lifestyle",
        "woman",
        "dogs",
        "shiba inu",
        "curly hair",
        "yellow",
        "navy blue",
        "bookshelf",
        "sofa",
        "curtains",
        "lamp",
        "collar"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-04.mp4",
      "description": "The video shows one person, an adult with a fair skin tone, wearing a top, a white t-shirt, along with light blue denim jeans and white sneakers, walking through a grassy area while holding a leash attached to a dog, viewed from behind. The dog is a medium sized animal with a black and tan, brown colored coat and a white blaze on its face, walking ahead of the person through the tall grass. The setting is an outdoor pine forest or woodland environment, showing tall green grass and wild seed heads swaying, rows of tall, slender pine tree trunks, and a hazy, bright, sunlit clearing visible in the distance between the trees. The lighting is bright and warm, consistent with golden hour sunlight filtering through the trees, creating a hazy, glowing backlight effect. The color palette is warm and natural, dominated by green, tan, brown, and gold tones, with a bright white and gold glow from the sun. The composition is a medium shot, low angle framing, with the person and dog positioned in the upper right portion of the frame and the tall grass filling the foreground. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a warm, golden hour glow and a moderate depth of field.",
      "keyElements": [
        "grass",
        "seed heads",
        "pine trees",
        "forest",
        "clearing",
        "leash",
        "jeans color",
        "backlight",
        "lighting"
      ],
      "attributes": [
        "peaceful",
        "candid",
        "medium shot",
        "low angle",
        "golden hour",
        "backlight",
        "warm lighting",
        "natural light",
        "warm tone",
        "hazy",
        "nature",
        "pet",
        "lifestyle",
        "dog",
        "leash",
        "walk",
        "pine trees",
        "forest",
        "grass",
        "green",
        "gold",
        "jeans",
        "denim"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-05.mp4",
      "description": "The video shows two people, one man and one girl, indoors interacting with a cat. The man is an adult male with a fair skin tone and short, gray and dark hair, along with light facial stubble, wearing a top, a green, teal colored sweater, smiling broadly, giving a warm, joyful, affectionate visible expression, while holding a treat up to the cat. The girl is a young child with a fair skin tone and light brown hair styled in a ponytail, wearing a top, a pink, white colored shirt patterned with small dogs, looking downward with a calm, curious visible expression. The cat is an animal with a long, fluffy white and gray colored coat, being held by the man, reaching toward the treat with one paw extended. The setting is an indoor home environment, showing a plain light gray wall, a framed picture partially visible on the left side of the frame, and a light colored blurred object in the foreground. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the group. The color palette is warm and neutral, dominated by teal, pink, white, and gray tones. The composition is a medium close up, closeup, upper body framing, with all three positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "wall",
        "framed picture",
        "treat",
        "sweater color",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "curious",
        "calm",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "pet",
        "family",
        "lifestyle",
        "man",
        "girl",
        "cat",
        "fluffy",
        "white",
        "gray hair",
        "teal",
        "pink",
        "treat",
        "ponytail"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-06.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone and blonde hair, wearing a white wristwatch, reaching up and gently touching the nose and muzzle of a horse, giving a calm, affectionate, gentle visible expression, with her head tilted upward toward the animal. The horse is a large animal with a dark brown, chestnut colored coat and a black mane, along with a white blaze marking down its face and long white whiskers visible on its muzzle. The setting is an indoor stable or barn environment, showing a wooden stall structure, a tan colored wall, a bright window letting in natural light, and a light colored curtain or fabric hanging nearby. The lighting is soft and warm, consistent with natural light filtering through the window combined with ambient barn lighting, creating gentle highlights on the horse's coat. The color palette is warm and rich, dominated by chestnut brown, tan, and black tones. The composition is an extreme close up, closeup, tight framing, with the horse's head filling the left portion of the frame and the woman's hand and face visible on the right side. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a shallow depth of field and warm, natural lighting.",
      "keyElements": [
        "stall",
        "wall",
        "window",
        "curtain",
        "wristwatch",
        "lighting"
      ],
      "attributes": [
        "calm",
        "affectionate",
        "gentle",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "soft lighting",
        "natural light",
        "warm tone",
        "equestrian",
        "lifestyle",
        "woman",
        "horse",
        "chestnut",
        "brown",
        "blonde hair",
        "stable",
        "barn",
        "muzzle",
        "wristwatch"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-07.mp4",
      "description": "The video shows one person's hand and arm, with a fair skin tone, wearing a top, a light gray, lavender colored ribbed knit sweater, gently stroking and holding a cat close to their body. The cat is an animal with a gray and black striped, tabby colored coat, with its eyes closed, giving a calm, relaxed, content visible expression, resting its head on the person's arm. The setting is an indoor home environment, showing a plain, blurred background with soft, muted tones. The lighting is soft, warm, and diffused, consistent with indoor ambient lighting, evenly illuminating the cat and the person's arm. The color palette is soft and neutral, dominated by gray, lavender, and white tones. The composition is an extreme close up, closeup, tight framing, focused on the cat's face and the person's arm and sweater sleeve, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field and soft, gentle lighting.",
      "keyElements": ["background", "sweater color", "lighting"],
      "attributes": [
        "calm",
        "relaxed",
        "content",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "soft lighting",
        "natural light",
        "warm tone",
        "pet",
        "lifestyle",
        "cat",
        "tabby",
        "gray",
        "lavender",
        "sweater",
        "knit",
        "sleeping",
        "stroking"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-08.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone and long, wavy light brown hair, wearing a top, a yellow, mustard colored knit sweater, along with a wristwatch and rings on her fingers, lying on a sofa and cuddling with a dog, giving a warm, joyful, affectionate visible expression, with a soft smile. The dog is a medium to large sized animal with a golden, cream colored coat, characteristic of a Golden Retriever breed, resting its head near the woman's face with its mouth slightly open. The setting is an indoor living room environment, showing a brown corduroy textured sofa, a light gray sofa with a teal, blue throw pillow and a red, orange throw pillow in the background, and a bright window letting in natural light with green foliage visible outside. The lighting is bright and natural, consistent with daylight coming through the window, evenly illuminating the woman and dog. The color palette is warm and rich, dominated by yellow, mustard, gold, and brown tones, with teal and red accents from the throw pillows. The composition is a medium close up, closeup, upper body framing, with the woman and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "window",
        "foliage",
        "wristwatch",
        "rings",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "pet",
        "lifestyle",
        "woman",
        "dog",
        "golden retriever",
        "yellow",
        "mustard",
        "gold",
        "sofa",
        "throw pillow",
        "teal",
        "red",
        "window",
        "wavy hair"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-09.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, wearing a helmet, a gray colored riding helmet with a chin strap, and black leather gloves, reaching out and gently touching the nose of a horse with her gloved hand, giving a calm, affectionate, gentle visible expression, with a soft smile. The horse is a large animal with a reddish brown, chestnut colored coat, wearing a black leather bridle with a metal ring and buckle detail near its muzzle. The setting is an outdoor equestrian environment, blurred softly out of focus behind the pair, showing green pine trees and a light colored fence or barrier. The lighting is soft and natural, consistent with overcast outdoor daylight, evenly illuminating the woman and horse without harsh shadows. The color palette is warm and neutral, dominated by chestnut brown, black, gray, and green tones. The composition is an extreme close up, closeup, tight framing, with the horse's muzzle filling the left portion of the frame and the woman's hand and face visible on the right side. The visual style is photographic, realistic, and resembles a lifestyle or equestrian style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "trees",
        "fence",
        "bridle",
        "helmet",
        "gloves",
        "lighting"
      ],
      "attributes": [
        "calm",
        "affectionate",
        "gentle",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "warm tone",
        "equestrian",
        "lifestyle",
        "woman",
        "horse",
        "chestnut",
        "brown",
        "helmet",
        "gloves",
        "bridle",
        "trees",
        "muzzle"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-10.mp4",
      "description": "The video shows a compilation of several distinct extreme macro nature shots edited together, with no people visible throughout. The video opens with pale pink and white flower blossoms, resembling apricot or cherry blossoms, with yellow stamens, dark red buds, and thin brown branches, set against a bright turquoise, blue colored background. The video transitions to a pair of orange, red colored ants walking along a dark brown tree branch against a blurred green background. The video then shows a time lapse of white, fuzzy mold or fungus growing and spreading across a dark brown surface. The video continues with a honeybee, an insect with a black and gold striped body and translucent wings, hovering near light purple, lavender colored daisy flowers with yellow centers, set against a blurred dark green background. The video then shows a backlit cross section of a kiwi fruit, displaying bright green flesh, a pale yellow center, and a ring of small black seeds. The video continues with raindrops falling and streaming off a bright green leaf against a dark green blurred background. The video then shows an extreme close up of a chameleon, a reptile with brightly colored scaled skin in red, green, orange, and turquoise patterns, gripping a branch with clawed feet. The video concludes with a backlit macro shot of a green leaf, displaying its intricate vein structure with small insects visible walking along the central vein. The lighting varies across segments, including bright natural daylight, soft diffused light, and strong backlighting that creates glowing, translucent effects on the flowers, fruit, and leaves. The color palette is vibrant and varied, spanning turquoise, pink, green, orange, gold, and red tones across the different segments. The composition is consistently an extreme close up, closeup, macro framing throughout, with each subject filling most of the frame. The visual style is photographic, realistic, and resembles a nature or wildlife documentary style stock video with a shallow depth of field and detailed macro focus throughout.",
      "keyElements": [
        "flower blossoms",
        "branch",
        "mold",
        "fungus",
        "bee",
        "daisy flowers",
        "kiwi fruit",
        "raindrops",
        "leaf",
        "chameleon",
        "leaf veins",
        "lighting"
      ],
      "attributes": [
        "vibrant",
        "colorful",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "macro",
        "shallow depth of field",
        "backlight",
        "natural light",
        "soft lighting",
        "time lapse",
        "documentary",
        "wildlife",
        "nature",
        "compilation",
        "montage",
        "flower",
        "blossom",
        "ant",
        "insect",
        "mold",
        "fungus",
        "bee",
        "honeybee",
        "daisy",
        "purple",
        "kiwi",
        "fruit",
        "seeds",
        "raindrops",
        "leaf",
        "chameleon",
        "reptile",
        "turquoise",
        "pink",
        "green",
        "gold"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-11.mp4",
      "description": "The video shows one man, an adult male with a fair skin tone and long, dark brown wavy hair, along with a full, thick dark beard, wearing eyeglasses, dark rimmed eyeglasses, and a top, a blue, teal colored button up shirt with rolled sleeves over a mustard, orange colored t-shirt, along with dark pants, sitting on a sofa and reaching out to pet a dog, giving a warm, joyful, affectionate visible expression, with a broad smile. The dog is a medium sized animal with a tan, cream colored coat and floppy ears, standing on the sofa cushions next to the man. The setting is an indoor living room environment, showing a light gray sofa with a teal, blue throw pillow, tall windows with sheer white curtains and brown drapes, a dark metal shelving unit holding stacked books and a small globe, vinyl records displayed on the wall, and a wood coffee table in the foreground. The lighting is bright and natural, consistent with daylight coming through the windows, evenly illuminating the man and dog. The color palette is warm and rich, dominated by teal, mustard, tan, and brown tones. The composition is a medium wide shot, full body framing, with the man and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a bright, casual look and a moderate depth of field.",
      "keyElements": [
        "sofa",
        "throw pillow",
        "windows",
        "curtains",
        "shelving unit",
        "books",
        "globe",
        "vinyl records",
        "coffee table",
        "shirt color",
        "eyeglasses",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "candid",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "warm tone",
        "casual",
        "pet",
        "lifestyle",
        "man",
        "dog",
        "beard",
        "eyeglasses",
        "glasses",
        "teal",
        "mustard",
        "sofa",
        "throw pillow",
        "windows",
        "shelving",
        "vinyl records",
        "coffee table"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-12.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone and long, light brown wavy hair styled in a ponytail, wearing a top, a pink, blush colored long sleeve shirt, along with blue denim jeans, sitting on the floor and playing with a dog, giving a joyful, warm, playful visible expression, with her eyes closed and a broad smile. The dog is a medium sized animal with a reddish brown and white colored coat, characteristic of a Nova Scotia Duck Tolling Retriever breed, standing on its hind legs with its front paws resting on the woman's shoulders, mouth open. The setting is an indoor living room environment, blurred softly out of focus behind the pair, showing a light gray sectional sofa with tan throw pillows, a bright window with sheer curtains, a small vase of yellow flowers, and light wood flooring. The lighting is bright and natural, consistent with daylight coming through the window, evenly illuminating the woman and dog. The color palette is warm and bright, dominated by pink, reddish brown, white, and tan tones. The composition is a medium close up, closeup, upper body framing, with the woman and dog positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field, keeping the background softly blurred.",
      "keyElements": [
        "sofa",
        "throw pillows",
        "window",
        "curtains",
        "vase",
        "flowers",
        "wood flooring",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "playful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "pet",
        "lifestyle",
        "woman",
        "dog",
        "retriever",
        "pink",
        "reddish brown",
        "white",
        "sofa",
        "throw pillow",
        "window",
        "flowers",
        "ponytail"
      ]
    },
    {
      "fileName": "GENERIC-HumanAnimalMacro-13.mp4",
      "description": "The video shows two animals, one dog and one cat, resting closely together indoors, with no people visible. The dog is an animal with a brown and white colored coat and long, floppy ears, resting its head near the cat, with dark brown eyes looking toward the camera, giving a calm, relaxed visible expression. The cat is an animal with a gray and white striped, tabby colored coat, lying with its eyes closed and one paw extended outward, giving a calm, peaceful, sleepy visible expression, resting its head against a woven basket edge. The setting is an indoor home environment, showing a brown and orange patterned fabric or blanket underneath the animals, a woven, wicker textured basket or bed frame, and a tan colored wall with visible texture or peeling paint in the background. The lighting is soft and warm, consistent with indoor ambient lighting, evenly illuminating the two animals. The color palette is warm and earthy, dominated by brown, tan, gray, and orange tones. The composition is an extreme close up, closeup, tight framing, with both animals filling most of the frame, positioned closely together. The visual style is photographic, realistic, and resembles a lifestyle or pet style stock video with a shallow depth of field and soft, warm lighting.",
      "keyElements": ["blanket", "fabric", "basket", "wall", "lighting"],
      "attributes": [
        "calm",
        "relaxed",
        "peaceful",
        "sleepy",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "soft lighting",
        "warm tone",
        "earthy tone",
        "pet",
        "lifestyle",
        "dog",
        "cat",
        "tabby",
        "brown",
        "gray",
        "white",
        "basket",
        "blanket",
        "resting",
        "sleeping"
      ]
    }
  ]
}
